import { memo } from 'react';
import { BiLeftArrowAlt } from 'react-icons/bi';
import Fab from '@material-ui/core/Fab';
import { LinkRouter } from '../link/Link';
import Tooltip from '@material-ui/core/Tooltip';
import { ContainerBack } from './ButtonStyle';

interface ButtonBackInterface {
    to: string;
}

function ButtonBack({ to }: ButtonBackInterface) {

    return (
        <ContainerBack>
            <LinkRouter to={to}>
                <Tooltip title="Voltar" aria-label="add">
                    <Fab color="primary" size="small" >
                        <BiLeftArrowAlt size={30} />
                    </Fab>
                </Tooltip>
            </LinkRouter>
        </ContainerBack>
    );
}

export default memo(ButtonBack);
